import {reactive} from "vue";
import type {CustomerModel} from "@/serviceWorker/workerComponents/Models/CustomerModel";

/**
 * stan służy za przechowywanie danych potencjalnego klienta pomiędzy tabami.
 * w momencie ponownego inicjalizowana engine odpalany jest reset().
 */
export const NfCustomerStore = reactive({
    customer: null as CustomerModel | null ,
    reset() {
        this.customer = null;
    }
})
